/**
 * Takes raw form data and prepares it for the API.
 * This handles: 
 * 1. Formatting the phone number with the country dial code.
 * 2. Converting text strings (like Revenue) into actual Numbers.
 */
export const prepareCollaboratorPayload = (clientData, countryCode, COUNTRY_OPTIONS, collaborator = {}) => {
  // Find the dial code (e.g., +1) based on the selected country
  const dialCode = COUNTRY_OPTIONS.find(opt => opt.id === countryCode)?.code || '';
  
  // Format the phone number string
  const finalPhone = clientData.phone 
    ? `${dialCode}${clientData.phone}` 
    : (collaborator?.phone || "");

  // Return a clean object with proper data types (Numbers for numeric fields)
  return {
    contact_person: clientData.name || collaborator?.contact_person || "",
    organization_name: clientData.organizationName || collaborator?.organization_name || "",
    email: clientData.email || collaborator?.email || "",
    phone: finalPhone,
    website: clientData.website || collaborator?.website || "",
    companyRevenue: Number(clientData.companyRevenue || collaborator?.companyRevenue || 0),
    employeeCount: Number(clientData.employeeCount || collaborator?.employeeCount || 0),
    foundedYear: Number(clientData.foundedYear || collaborator?.foundedYear || 0),
    gender: clientData.gender || collaborator?.gender || '',
    businessType: clientData.businessType || collaborator?.businessType || '',
    veteranStatus: clientData.veteranStatus || collaborator?.veteranStatus || '',
    disabled: clientData.disabled || collaborator?.disabled || '',
    proposals: clientData.proposals || collaborator?.proposals || {},
  };
};